import {FC, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Formik} from 'formik';
import {Popup, Button} from '@tickchak/react-share/app';
import {TShow} from '../../../../../../hooks/useShow';
import LecturerTab from './LecturerTab';
import AboutTab from './AboutTab';
import PopupHeaderEnd from './PopupHeaderEnd';
import {submitLecturer} from './submit';
import {TabId, initialValues, buildSchema} from './types';
import * as css from '../AddLecturerPopup.css';

interface Props {
    show: TShow;
}

const AddLecturerPopup: FC<Props> = ({show}) => {
    const {t} = useTranslation('timetable');
    const [activeTab, setActiveTab] = useState<TabId>('lecturer');
    const [isActive, setIsActive] = useState(false);

    if(!show.isOpen) return null;

    const close = () => show.close();
    const tabs = [
        {id: 'lecturer' as const, label: t('tabLecturer')},
        {id: 'about' as const, label: t('tabAbout')},
    ];

    return (
            <Popup show={show} data-cy="addLecturerPop">
                <Popup.Tabs
                    tabs={tabs}
                    value={activeTab}
                    onChange={v => setActiveTab(v as TabId)}
                    header={
                        <Popup.Header
                            title={t('manageLecturer')}
                            onClose={close}
                            endSlot={<PopupHeaderEnd isActive={isActive} onToggle={setIsActive} t={t} />}
                        />
                    }
                >
                    <Formik
                        initialValues={initialValues}
                        validationSchema={buildSchema(t('fieldRequired'))}
                        onSubmit={v => submitLecturer(v, close)}
                    >
                        {({submitForm, isSubmitting}) => (
                            <>
                                <css.form placeholder="" onPointerEnterCapture={() => {}} onPointerLeaveCapture={() => {}}>
                                    {activeTab === 'lecturer' ? <LecturerTab t={t} /> : <AboutTab t={t} />}
                                </css.form>
                                <css.footer>
                                    <Button variant="neutral" size="category" onClick={close} type="button" disabled={isSubmitting}>
                                        {t('cancel')}
                                    </Button>
                                    <Button variant="brand" size="category" onClick={submitForm} type="button" disabled={isSubmitting}>
                                        {t('createLecturer')}
                                    </Button>
                                </css.footer>
                            </>
                        )}
                    </Formik>
                </Popup.Tabs>
            </Popup>
    );
};

export default AddLecturerPopup;
